const protocol = `
<div>
            <p class="p3">本政策仅适用于优课达（杭州）网络有限公司，下简称“优课达”提供的服务。<br>
                        最近更新日期：2021年1月26日。<br>
                        如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：<br>
                        电子邮件：yebing@youkeda.com， <br>
                        客服电话：057128874897<br>
                        优课达公司名称：优课达（杭州）网络有限公司<br>
                        注册地址：杭州市余杭区文一西路1818-2号9幢806</p>
            <p class="p4">优课达深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，优课达承诺，我们将按业界成熟的安全标准，采取适当的安全保护措施来保护您的个人信息。<br>
                        请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》。
                        <strong>本政策将帮助您了解以下内容：</strong></p>
            <ol class="ol1">
                <li class="li5">我们如何收集和使用您的个人信息</li>
                <li class="li5">我们如何使用 Cookie 和同类技术</li>
                <li class="li5">我们如何共享、转让、公开披露您的个人信息</li>
                <li class="li5">我们如何保护您的个人信息</li>
                <li class="li5">您的权利</li>
                <li class="li5">我们如何处理儿童的个人信息</li>
                <li class="li5">您的个人信息如何在全球范围转移</li>
                <li class="li5">本政策如何更新</li>
                <li class="li5">如何联系我们</li>
            </ol>
            <h3>一、我们如何收集和使用您的个人信息</h3>
            <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。优课达仅会出于本政策所述的以下目的， 收集和使用您的个人信息：</p>
            <p>（一）实现优课达基本功能</p>
            <p>1、通过注册账号收集的信息</p>
            <p>您需要在优课达APP中注册或登录优课达帐号，当您注册优课达账号时，优课达会收集您的手机 号码、用户名、密码，收集这些信息是为了帮助您完成优课达账号注册，保护您的账号安全。如果您拒绝提供这些信息，您可能无法正常注册优课达账号，也无法享受我们提供的基于账号的个性化服务。您也可以通过“优课达->我的->个人信息”界面修改用户名、头像。</p>
            <p>2、间接收集的信息</p>
            <p>为方便您登录优课达账号，您可以通过微信、QQ第三方账号登陆本款产品及优课达的其他产品和服务。为实现前述目的，我们可能需要从第三方获取并收集您的第三方账号信息，如昵称、头像。除上述情况外，目前优课达不会主动从第三方获取您的个人信息，如果未来业务发展需要从第三方间接获取您的个人信息，我们会在获取前向您明示个人信息的来源、类型及使用范围。如果优课达开展业务需要进行的个人信息处理活动超出了您向第三方授权同意的处理范围，我们将在处理您的个人信息前征得您的明示同意。 我们也将严格遵守相关法律规定，要求第三方保障其提供的信息的合法性。</p>
            <p>3、第三方分享</p>
            <p>在优课达APP中，您可以将各种活动信息通过第三方平台分享给您的朋友。在您分享的过程中，第三方平台会要求您进行登录或注册，您需要手动输入您在第三方产品的用户名和密码进行注册或登录。优课达APP不会保存也不会监控第三方产品的用户名和密码，同时，也不会将您的手机号或您在优课达设备中使用的用户名和密码发送给第三方。</p>
            <p>（二）基于位置的个性化服务</p>
            <p>当您完成优课达APP安装后，您可以通过弹窗选择是否允许我们收集您的GPS位置信息。如果您同意我们收集您的GPS位置信息，您可以使用优课达APP快速导航至绑定终端位置。 拒绝提供位置信息仅会使您无法享受基于前述基于位置的服务，而不会影响您正常使用本款产品的其他功能。</p>
            <p>（三）安全保障</p>
            <p>为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或优课达相关协议规则的情况。我们可能使用或整合您的账户信息、设备信息、软件使用信息以及我们关联公司、 合作伙伴取得您授权或依据法律共享的信息，用于进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</p>
            <p>（四）征得授权同意的例外</p>
            <p>当我们要将信息用于本政策未载明的其它用途时，会事先征求您的同意。当我们要将基于特定目的收集而来的信息用于其他目的时， 会事先征求您的同意。如您需撤回同意权限，可通过手机设置-优课达应用内关闭相应权限。<br>
              根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p>
            <p>（一）实现优课达基本功能</p>
            <p>（一）实现优课达基本功能</p>
            <ol class="ol1">
                <li class="li5">与国家安全、国防安全有关的；</li>
                <li class="li5">与公共安全、公共卫生、重大公共利益有关的；</li>
                <li class="li5">与犯罪侦查、起诉、审判和判决执行等有关的；</li>
                <li class="li5">出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</li>
                <li class="li5">所收集的个人信息是您自行向社会公众公开的；</li>
                <li class="li5">从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
                <li class="li5">根据您的要求签订合同所必需的；</li>
                <li class="li5">用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</li>
                <li class="li5">为合法的新闻报道所必需的；</li>
                <li class="li5">学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结 果中所包含的个人信息进行去标识化处理的；</li>
            </ol>
            <h3>二、我们如何使用 Cookie 和同类技术</h3>
            <p>为使您获得更轻松的访问体验，您使用优课达的产品或服务时，我们可能会通过采用各种技术收集和存储您访问优课达服务的相关数据，在您访问或再次访问优课达服务时，我们能识别您的身份，并通过分析数据为您提供更好更多的服务。包括使用小型数据文件识别您的身份，以便了解您的使用习惯，帮您省去重复输入账户信息的步骤，或者帮助判断您的账户安全。 这些文件可能是Cookie\Flash Cookie,或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie")。</p>
            <p>您有权选择接受或拒绝接受Cookie。您可以通过修改浏览器设置的方式拒绝接受Cookie。 但如果您选择拒绝接受Cookie，则您可能无法登录或使用依赖于Cookie的本应用网络服务或功能。</p>
            <p>通过本应用所设Cookie所取得的有关信息，将适用本政策。</p>
            <h3>三、我们如何共享、转让、公开、披露您的个人信息</h3>
            <p>为了保证您的个人信息安全，我们遵照最小化原则，在遵守适用的法律要求下，共享、转让或披露您的个人信息。</p>            
            <p>对我们与之共享个人信息的公司、组织和个人，我们会按照当地国家的法律要求采取组织和技术措施，要求他们按照我们的安全标准、本政策的要求及相关的保密和安全措施来处理个人信息。</p>
            <p>（一）共享</p>
            <p>我们不会与优课达以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</p>
            <ol class="ol1">
                <li class="li5">在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
                <li class="li5">我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</li>
                <li class="li5">与我们的附属公司共享：您的个人信息可能会与南京优课达的附属公司共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束。 附属公司如要改变个人信息的处理目的，将再次征求您的授权同意。</li>
                <li class="li5">与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。</li>
            </ol>
            <p>您在使用潮品精选购买我们的产品时，我们必须与物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。 我们的合作伙伴无权将共享的个人信息用于任何其他用途</p>
            <p>（二）转让</p>
            <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
            <ol class="ol1">
                <li class="li5">在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</li>
                <li class="li5">在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>
            </ol>
            <p>（三）公开披露</p>
            <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
            <ol class="ol1">
                <li class="li5">获得您明确同意后；</li>
                <li class="li5">基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</li>
            </ol>
            <h3>四、我们如何保护您的个人信息</h3>
            <p>（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息， 防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。 我们会采取一切合理可行的措施，保护您的个人信息。</p>                        
            <p>（二）我们的数据安全能力：<br>
                我们一直致力于保护您的个人信息安全。<br>
                我们通过采取各种安全保障措施，比如门禁系统、监控系统、加密、匿名或假名化、员工培训等，保护您的个人信息不被未经授权地访问、使用、披露、修改、损坏或丢失及其它的形式的非法处理。</p>
            <p>（三）我们制定了业务连续性计划，以保证可以连续地提供服务；我们的信息安全政策和程序严格按照国际标准进行设计，定期进行审核和更新，通过定期的第三方安全审计，确保安全管理架构和措施的有效性。中兴通讯股份有限公司及部分子公司已经通过了ISO 27001信息安全认证，可以有效保护您的个人信息。如发生个人信息泄露事件，我们会启动应急预案，采取有效措施防止事态扩大，并及时通知相关监管机构和您。</p>
            <p>（四）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
            <p>（五）互联网并非绝对安全的环境，而且多数电子邮件、即时通讯等交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>
            <p>（六）我们将定期更新并公开安全风险、个人信息安全影响评估等报告的有关内容。如果我们在安全评估报告中影响你的个人信息相关权利，我们会主动公开安全风险。如果您希望获得详细的报告内容，您可通过以下方式获得： E-mail: Privacy@zte.com.cn</p>
            <p>（七）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。<br>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。<br>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
            <h3>五、您的权利</h3>
            <p>按照个人信息保护相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
            <p>（一）访问您的个人信息</p>
            <p>您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：<br>
               用户信息——如果您希望访问或编辑您的账户中的个人资料信息、设置通知方式，您可以通过访问APP“我的”执行此类操作。<br>
               如果您无法通过上述链接/方式访问这些个人信息，您可以发送电子邮件至yebing@youkeda.com。我们将在15天内回复您的访问请求。对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。</p>
            <p>（二）更正您的个人信息</p>
            <p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“（一）访问您的个人信息”中罗列的方式提出更正申请。如果您无法通过上述链接更正这些个人信息， 您可以随时发送电子邮件至yebing@youkeda.com, 我们将在15天内回复您的更正请求。</p>
            <p>（三）删除您的个人信息</p>
            <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
            <ol class="ol1">
                <li class="li5">如果我们处理个人信息的行为违反法律法规；</li>
                <li class="li5">如果我们收集、使用您的个人信息，却未征得您的同意；</li>
                <li class="li5">如果我们处理个人信息的行为违反了与您的约定；</li>
                <li class="li5">如果您不再使用我们的产品或服务，或您注销了账号；</li>
                <li class="li5">如果我们不再为您提供产品或服务。</li>
            </ol>
            <p>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
            <p>（四）个人信息主体注销账户</p>
            <p>您随时可注销此前注册的账户，您可以通过以下方式操作：</p>
            <ol class="ol1">
                <li class="li5">您可以随时拨打客服电话0571-28874897进行账户注销；</li>
                <li class="li5">您可以随时发送电子邮件至yebing@youkeda.com, 我们将在15天内回复您； 在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定</li>
            </ol>
            <p>（五）响应您的上述请求</p>
            <p>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份， 然后再处理您的请求，我们会在十五天内做出答复。</p>
            <p>对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。 在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
            <ol class="ol1">
                <li class="li5">与国家安全、国防安全直接相关的；</li>
                <li class="li5">与公共安全、公共卫生、重大公共利益直接相关的；</li>
                <li class="li5">与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
                <li class="li5">有充分证据表明您存在主观恶意或滥用权利的；</li>
                <li class="li5">响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</li> 
                 <li class="li5">涉及商业秘密的。</li>                   
            </ol>
            <h3>六、我们如何处理儿童的个人信息</h3>
            <p>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。</p>
            <p>对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。</p>
            <p>尽管当地法律和习俗对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。</p>
            <p>如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。</p>
            <h3>七、您的个人信息如何在全球范围转移</h3>
            <p>优课达服务仅面向中华人民共和国境内用户，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</p>
            <h3>八、本政策如何更新</h3>
            <p>我们的隐私政策可能变更。<br>
               未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。<br>
               我们会在本页面上发布对本政策所做的任何变更。对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过电子邮件发送通知，说明隐私政策的具体变更内容）。</p>
            <ol class='ol1'>
              本政策所指的重大变更包括但不限于：
              <li class='li5'>我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</li>
              <li class='li5'>我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</li>
              <li class='li5'>个人信息共享、转让或公开披露的主要对象发生变化；</li>
              <li class='li5'>您参与个人信息处理方面的权利及其行使方式发生重大变化；</li>
              <li class='li5'>我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</li>
              <li class='li5'>个人信息安全影响评估报告表明存在高风险时。</li>
            </ol>
            <p>我们还会将本政策的旧版本存档，供您查阅。</p>
            <h3>九、如何联系我们</h3>
            <p>我们设立了个人信息保护专职部门——数据保护合规部，如果您对本隐私政策有任何疑问、意见或建议， 您可以通过邮箱与我们联系，发送邮件至yebing@youkeda.com  和我们联系，我们将在15天内答复。</p>
            <p>收件人：优课达数据保护合规部</p>
            <p>地址：杭州市余杭区文一西路1818-2号人工智能小镇9幢806</p>
            <p>邮编：310000</p>
        </div>
`;

export { protocol }